import AuctionPenCardsView from "./AuctionPenCardsView";

export default AuctionPenCardsView;
